export const setTaskDetails = (
  taskDetails: TaskJoinedToUserAndScheduledObject
) => ({
  type: "SET_TASK_DETAILS",
  taskDetails,
});
